import standardAPI from '@/api/standard_items';

const state = {
  point_transit: [],
  point_transit_status: '',
  point_transit_MetaData: {},
  point_transit_page: 1,
  point_transit_perPage: 10,
};

const responseUrl = '/point-transit';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_point_transit ({ commit }, getOptions) {
    commit('POINT_TRANSIT_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('POINT_TRANSIT_SUCCESS', response);
            commit('POINT_TRANSIT_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('POINT_TRANSIT_READY');
            reject(response);
          } else {
            commit('POINT_TRANSIT_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_point_transit_item ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        if (response && response.id) {
          resolve(response);
        } else {
          reject(response);
        }
      }, preparedOptions);
    });
  },
  add_point_transit ({ commit, dispatch }, itemData) {
    commit('POINT_TRANSIT_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('POINT_TRANSIT_READY');
          reject(response);
        }
      });
    });
  },
  edit_point_transit ({ commit, dispatch }, itemData) {
    commit('POINT_TRANSIT_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('POINT_TRANSIT_READY');
          reject(response);
        }
      });
    });
  },
  remove_point_transit ({ commit, dispatch }, itemData) {
    commit('POINT_TRANSIT_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('POINT_TRANSIT_READY');
          reject(response);
        }
      });
    });
  },
  reorder_point_transit ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.point_transit_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.point_transit_perPage = max;
  },
  POINT_TRANSIT_READY: (state) => {
    state.point_transit_status = 'ready';
  },
  POINT_TRANSIT_REQUEST: (state) => {
    state.point_transit_status = 'loading';
  },
  POINT_TRANSIT_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.point_transit_MetaData.meta = response.meta;
      state.point_transit_MetaData.links = response.links;
    }
    state.point_transit = response.data;
    state.point_transit_status = 'success';
  },
  POINT_TRANSIT_ERROR: (state) => {
    state.point_transit_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
